<template>
  <footer id="footer">
    <p>
      Built with
      <a href="https://vuejs.org/" target="_blank">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 400 400">
          <path
            d="M237.417 86.655l-30.226 52.352-30.225-52.352H76.311l130.88 226.69 130.88-226.69z"
            fill="#4dba87"
          ></path>
          <path
            d="M237.417 86.655l-30.226 52.352-30.225-52.352h-48.303l78.528 136.014L285.72 86.655z"
            fill="#435466"
          ></path>
        </svg>
      </a>
      &
      <a href="https://buttercms.com" target="_blank">
        <img src="https://cdn.buttercms.com/RyJ7UhcVTCRqrCFXwgCo" alt>
      </a>
    </p>
  </footer>
</template>

<script>
export default {
  name: "Footer"
};
</script>

<style scoped>
#footer {
  position: fixed;
  width: 100%;
  bottom: 0;
  left: 0;
  height: 50px;
  background: #000;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
}

#footer p {
  margin: 0;
  line-height: 1;
  display: flex;
  align-items: center;
  text-transform: uppercase;
  font-size: 60%;
  letter-spacing: 1px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.6);
}

#footer img,
#footer svg {
  height: 30px;
  width: auto;
  margin-left: 10px;
  margin-right: 10px;
}
</style>
